<template>
  <div>
    <!-- ===================== Sidebar ===================== -->
    <v-navigation-drawer
      app
      v-if="user.email"
      v-model="drawer"
      width="264"
      color="#0E2A2F"
      dark
      class="dj-sidebar"
    >
      <!-- Brand -->
      <router-link
        :to="roleName != 'Supplier' ? '/dashboards' : ''"
        class="dj-sidebar__brand"
      >
        <div class="dj-sidebar__logo">
          <v-img
            alt="DJ"
            :src="require('../../assets/logo.png')"
            width="46"
            contain
          ></v-img>
        </div>
        <div class="dj-sidebar__brand-text">
          <div class="dj-sidebar__brand-name">DJ</div>
          <div class="dj-sidebar__brand-sub">Marine Suite</div>
        </div>
      </router-link>

      <!-- Navigation -->
      <v-list nav class="dj-sidebar__nav">
        <p class="dj-sidebar__label">Menu</p>

        <v-list-item to="/dashboards" v-if="roleName != 'Supplier'" link>
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>

        <v-list-item to="/projects" v-if="roleName != 'Supplier'" link>
          <v-list-item-icon>
            <v-icon>mdi-clipboard-text-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Projects</v-list-item-title>
        </v-list-item>

        <v-list-item
          to="/quotations?type=QUOTATION"
          v-if="roleName != 'Supplier'"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Quotation</v-list-item-title>
        </v-list-item>

        <v-list-item
          to="/users"
          v-if="
            roleName == 'Main Admin' ||
            roleName == 'Super Admin' ||
            roleName == 'Admin'
          "
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Users</v-list-item-title>
        </v-list-item>

        <template v-if="roleName != 'Supplier'">
          <p class="dj-sidebar__label">Configuration</p>
          <v-list-group
            prepend-icon="mdi-cog-outline"
            no-action
            class="dj-sidebar__group"
          >
            <template v-slot:activator>
              <v-list-item-title>Settings</v-list-item-title>
            </template>

            <v-list-item to="/values" link>
              <v-list-item-icon>
                <v-icon>mdi-format-list-text</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Values</v-list-item-title>
            </v-list-item>

            <v-list-item to="/value-lists" link>
              <v-list-item-icon>
                <v-icon>mdi-format-list-bulleted-square</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Value Lists</v-list-item-title>
            </v-list-item>

            <v-list-item to="/suppliers" link>
              <v-list-item-icon>
                <v-icon>mdi-truck-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Suppliers</v-list-item-title>
            </v-list-item>

            <v-list-item to="/templates?type=TEMPLATE" link>
              <v-list-item-icon>
                <v-icon>mdi-file-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Templates</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <!-- User footer -->
      <template v-slot:append>
        <div class="dj-sidebar__user">
          <v-avatar color="primary" size="38">
            <v-icon dark small>mdi-account</v-icon>
          </v-avatar>
          <div class="dj-sidebar__user-info">
            <div class="dj-sidebar__user-name">
              {{ user.first_name != null ? user.first_name : user.email }}
            </div>
            <div class="dj-sidebar__user-role">{{ roleName }}</div>
          </div>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="logout">
                <v-icon small>mdi-logout</v-icon>
              </v-btn>
            </template>
            <span>Logout</span>
          </v-tooltip>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- ===================== Top bar ===================== -->
    <v-app-bar
      app
      flat
      height="66"
      color="white"
      class="dj-appbar"
      v-if="user.email"
    >
      <v-app-bar-nav-icon
        class="dj-appbar__toggle"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-btn icon v-if="roleName != 'Supplier'" class="mr-1">
        <v-badge dot color="pink" offset-x="8" offset-y="8">
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>

      <v-menu offset-y bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="dj-appbar__account" v-bind="attrs" v-on="on">
            <div class="dj-appbar__account-text">
              <span class="dj-appbar__hello">{{
                user.first_name != null ? user.first_name : user.email
              }}</span>
              <span class="dj-appbar__role">{{ roleName }}</span>
            </div>
            <v-avatar color="primary" size="36" class="ml-2">
              <v-icon dark small>mdi-account</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense nav>
          <v-list-item @click="logout">
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="roleName != 'Supplier'">
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-bell-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Notification</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <router-view />
  </div>
</template>

<script type="text/javascript">
import { mapActions } from "vuex";

export default {
  data() {
    return {
      drawer: null,
    };
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    logout() {
      this.logOut();
      location.replace("/");
    },
  },
};
</script>

<style scoped>
/* ---------------- Sidebar: the instrument housing ---------------- */
.dj-sidebar {
  background: var(--dj-ink) !important;
  border-right: 1px solid var(--dj-on-ink-line) !important;
  box-shadow: none !important;
}
.dj-sidebar__brand {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 18px 18px 16px;
  text-decoration: none;
  border-bottom: 1px solid var(--dj-on-ink-line);
}
.dj-sidebar__logo {
  flex: 0 0 auto;
  background: #ffffff;
  border: 1px solid var(--dj-on-ink-line);
  border-radius: 12px;
  padding: 6px;
  line-height: 0;
  box-shadow: 0 6px 16px -8px oklch(0 0 0 / 0.6);
}
.dj-sidebar__brand-text {
  min-width: 0;
}
.dj-sidebar__brand-name {
  font-family: var(--dj-display);
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--dj-on-ink);
  line-height: 1;
}
.dj-sidebar__brand-sub {
  font-family: var(--dj-mono);
  font-size: 0.62rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--dj-brass-bright);
  margin-top: 4px;
}
.dj-sidebar__nav {
  padding: 10px;
  background: transparent;
}
.dj-sidebar__label {
  font-family: var(--dj-mono);
  font-size: 0.6rem;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--dj-on-ink-faint);
  margin: 14px 12px 6px;
}
.dj-sidebar__nav > .dj-sidebar__label:first-child {
  margin-top: 4px;
}
/* Tight, uniform rows — kill Vuetify's inflated icon margins */
.dj-sidebar ::v-deep .v-list-item {
  min-height: 42px !important;
  margin-bottom: 2px;
  padding: 0 12px;
  border-radius: 9px;
  color: var(--dj-on-ink-soft) !important;
  position: relative;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.dj-sidebar ::v-deep .v-list-item__icon {
  margin: 0 12px 0 0 !important;
  min-width: 22px;
  height: 42px;
  align-self: center;
}
.dj-sidebar ::v-deep .v-list-item .v-icon {
  color: var(--dj-on-ink-faint);
  font-size: 20px;
}
.dj-sidebar ::v-deep .v-list-item__title {
  font-weight: 500;
  font-size: 0.9rem;
}
.dj-sidebar ::v-deep .v-list-item:hover:not(.v-list-item--active) {
  background: oklch(1 0 0 / 0.06);
  color: var(--dj-on-ink) !important;
}
.dj-sidebar ::v-deep .v-list-item:hover:not(.v-list-item--active) .v-icon {
  color: var(--dj-on-ink-soft);
}
/* Active row: lit by a brass instrument bar, not a filled pill */
.dj-sidebar ::v-deep .v-list-item--active {
  background: oklch(1 0 0 / 0.08);
  color: var(--dj-brass-bright) !important;
}
.dj-sidebar ::v-deep .v-list-item--active::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--dj-brass-bright);
  box-shadow: 0 0 12px 0 var(--dj-brass-ring);
  opacity: 1;
}
.dj-sidebar ::v-deep .v-list-item--active .v-list-item__title {
  font-weight: 600;
}
.dj-sidebar ::v-deep .v-list-item--active .v-icon {
  color: var(--dj-brass-bright) !important;
}
/* Settings sub-items: indent under the group, slightly quieter */
.dj-sidebar ::v-deep .v-list-group--no-action .v-list-group__items .v-list-item {
  padding-left: 20px;
}
.dj-sidebar ::v-deep .v-list-group__items .v-list-item .v-icon {
  font-size: 18px;
}
.dj-sidebar__user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-top: 1px solid var(--dj-on-ink-line);
  background: oklch(1 0 0 / 0.03);
}
.dj-sidebar__user-info {
  flex: 1;
  min-width: 0;
}
.dj-sidebar__user-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--dj-on-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dj-sidebar__user-role {
  font-family: var(--dj-mono);
  font-size: 0.64rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--dj-on-ink-faint);
}

/* ---------------- Top bar ---------------- */
.dj-appbar {
  background: var(--dj-surface) !important;
  border-bottom: 1px solid var(--dj-border) !important;
}
.dj-appbar__account {
  height: 46px !important;
  padding: 0 6px 0 12px !important;
}
.dj-appbar__account-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.15;
}
.dj-appbar__hello {
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--dj-text);
  text-transform: none;
}
.dj-appbar__role {
  font-size: 0.68rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--dj-text-faint);
}
@media (max-width: 600px) {
  .dj-appbar__account-text {
    display: none;
  }
}
</style>
